import { Button, Checkbox, InputNumber, Space, Tooltip } from "antd";
import { useState } from "react";

export const OverrideDatapointField = ({
  metric,
  value,
  handleChange,
  fillWithAverage,
  revertChange,
  avg,
  type,
  metricIdentifier,
  has_rpe = false,
  updateRPE = false,
  handleUpdateRPE = () => {},
}) => {
  return (
    <div className="team-settings-input-wrap settings-inline-field">
      <div className="team-settings-input-label">{metric["name"]}</div>
      <Space.Compact>
        <InputNumber
          type="number"
          min="0"
          step="1"
          id={metric["key"]}
          name={metric["key"]}
          value={value}
          className="team-settings-input-stick"
          onChange={handleChange}
        />
        <Tooltip title="Fill with team average value">
          <Button
            className="team-settings-button team-settings-button-avg"
            onClick={() => fillWithAverage("team_avg")(type=='testing' ? metric["name"] : metric["key"], metricIdentifier)}
          >
            Team Avg: {(avg?.team_avg?.[type=='testing' ? metric["name"] : metric["key"]] || 0).toFixed(2)}
          </Button>
        </Tooltip>
        <Tooltip title="Fill with position average value">
          <Button
            className="team-settings-button team-settings-button-avg"
            onClick={() => fillWithAverage("pos_avg")(type=='testing' ? metric["name"] : metric["key"], metricIdentifier)}
          >
            Pos Avg: {(avg?.pos_avg?.[type=='testing' ? metric["name"] : metric["key"]] || 0).toFixed(2)}
          </Button>
        </Tooltip>
        <Tooltip title="Undo the change">
          <Button
            className="team-settings-button team-settings-button-undo"
            onClick={() => revertChange(metric["key"], metricIdentifier)}
          >
            Undo
          </Button>
        </Tooltip>
      </Space.Compact>
        {(has_rpe && metric?.key === 'total_time') && (
          <Tooltip title="Selecting this will update the calculated Session RPE values" placement="right">
            <Checkbox className="settings-inline-extra" style={{ marginTop: 3 }} checked={updateRPE} onChange={(e) => {handleUpdateRPE(e?.target?.checked)}}>
              Update corresponding Session RPE data
            </Checkbox>
          </Tooltip>
        )}
    </div>
  );
};
